import React, { useEffect, useState } from "react";
import { RequestModal } from "../requestModal/RequestModal";
import "./DevicesSection.css";

interface MainSectionProps {
    selectionState?: string;
    setSelectionState: (val: string) => void;
}

export const DevicesSection: React.FC<MainSectionProps> = ({ setSelectionState }) => {
    const [organizationsData, setOrganizationsData] = useState<Array<string>[]>([]);
    const [isOpenRequestModal, setIsOpenRequestModal] = useState<boolean>(false);
    const [selectedOrganization, setSelectedOrganization] = useState<string[]>([]);
    const [filteredItems, setFilteredItems] = useState<Array<string>[]>([]);
    const [query, setQuery] = useState('');

    const handleFilter = () => {
        if (query) {
            setFilteredItems(organizationsData.filter(item => item[2].toLowerCase().includes(query.toLowerCase())));
        } else {
            setFilteredItems(organizationsData);
        }
    };

    const handleReset = () => {
        setQuery('');
        setFilteredItems(organizationsData);
    };

    const handleClickBtn = (data: string[]) => {
        setIsOpenRequestModal(true);
        setSelectedOrganization(data);
    };

    const handleCloseModal = () => {
        setIsOpenRequestModal(false);
        setSelectedOrganization([]);
    };

    const handleNewRequest = () => {
        const userName = sessionStorage.getItem("userName");

        const requestData = {
            action: "SHOW_EQUIPMENT_LIST",
            user_name: userName,
        };

        if (window.ws && window.ws.readyState === WebSocket.OPEN) {
            window.ws.send(JSON.stringify(requestData));
            window.ws.onmessage = (event: { data: string; }) => {
                const message = JSON.parse(event.data);
                if (message?.EQUIPMENT_LIST && message.EQUIPMENT_LIST.length !== 0) {
                    console.log(`kek`,message.EQUIPMENT_LIST)
                    setOrganizationsData([...message.EQUIPMENT_LIST]);
                    setFilteredItems([...message.EQUIPMENT_LIST]);
                }
            };
        } else {
            console.error("Ошибка соединения с сервером");
        }
    };

    useEffect(() => {
        handleNewRequest(); // Запрос данных оборудования при загрузке компонента
    }, []);

    return (
        <div className="devices-section-content">
            <div className="header">
                <h2>Список оборудования</h2>
            </div>
            <div className="body">
                <span>Введите серийный номер:</span>
                <input
                    type="text"
                    placeholder="Введите текст для фильтрации..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <button onClick={handleFilter}>Искать</button>
                <button onClick={handleReset}>Сбросить</button>

                {filteredItems.length > 0 ? (
                    <ul className="organization-list">
                        {filteredItems.map((org, index) => (
                            <li key={index} className="organization-item">
                                <div className="organization-list-data">
                                    <div><span>Оборудование: </span><span>{org[1]}</span></div>
                                    <div><span>Серийный номер: </span><span>{org[2]}</span></div>
                                    <span>{org[0]}</span>
                                    <div><span>Истекает: </span><span>{org[4]}</span> {isDateValid(org[4]) ? <span className={'color-green'}>Действует</span>:<span  className={'color-red'}>Истек</span>}</div>

                                </div>
                                <button disabled={!isDateValid(org[4])} onClick={() => handleClickBtn(org)}>Создать обращение</button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>Данного серийного номера нет в списке оборудования. Обратитесь Call Center или в Service desk.</p>
                )}
            </div>

            <RequestModal
                isOpen={isOpenRequestModal}
                onClose={handleCloseModal}
                data={selectedOrganization}
                setSelectionState={setSelectionState}
            />
        </div>
    );
};

const isDateValid = (dateString: string): boolean => {
    const inputDate = new Date(dateString);
    const currentDate = new Date();

    return inputDate >= currentDate;
};